import { z } from 'zod';
import { Abrechnungsmodell, BetreuungArt } from '../enums.js';
/**
 * Betreuung — der Vertrag, unter dem eine Liegenschaft betreut wird.
 *
 * Warum eine eigene Entität neben `Liegenschaft.status`: Der Status sagt, OB
 * das Objekt gerade betreut wird. Die Betreuung sagt, WIE — als bestellter
 * Brandschutzbeauftragter, als Berater oder nur zur Wartung — und seit wann,
 * unter welcher Bestellnummer, zu welchem Abrechnungsmodell. Aus der Art folgt,
 * ob die Aufgaben des Katalogs verbindlich oder empfohlen sind.
 *
 * Mehrere Betreuungen je Objekt sind die Historie: erst Beratung, dann
 * Bestellung, nach zwei Jahren Wechsel des Modells. „Aktiv" ist, was kein Ende
 * hat oder dessen Ende in der Zukunft liegt.
 */
export const betreuung = z.object({
    id: z.number().int().positive(),
    liegenschaftId: z.number().int().positive(),
    art: BetreuungArt,
    beginn: z.string().datetime(),
    ende: z.string().datetime().nullable().optional(),
    /** Die eigene Bestellnummer des Kunden je Standort. */
    bestellnummer: z.string().nullable().optional(),
    abrechnungsmodell: Abrechnungsmodell,
    bestellurkundeDocumentId: z.number().int().positive().nullable().optional(),
    notiz: z.string().nullable().optional(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const createBetreuungRequest = betreuung
    .omit({ id: true, liegenschaftId: true, createdAt: true, updatedAt: true })
    .extend({
    bestellnummer: z.string().trim().max(120).nullable().optional(),
    abrechnungsmodell: Abrechnungsmodell.default('einzel'),
    notiz: z.string().max(5000).nullable().optional(),
    /**
     * Aufgaben aus dem Katalog anlegen?
     *
     * Bei einer Bestellung als Brandschutzbeauftragter ist das der Regelfall
     * und die Vorgabe `true` — der Katalog IST die Ankreuzliste des
     * Bestellungsschreibens. Bei Beratung und Wartung nur auf Wunsch.
     */
    mitAufgaben: z.boolean().optional(),
})
    .refine((b) => !b.ende || new Date(b.ende).getTime() >= new Date(b.beginn).getTime(), {
    message: 'Das Ende darf nicht vor dem Beginn liegen.',
    path: ['ende'],
});
export const updateBetreuungRequest = z.object({
    art: BetreuungArt.optional(),
    beginn: z.string().datetime().optional(),
    ende: z.string().datetime().nullable().optional(),
    bestellnummer: z.string().trim().max(120).nullable().optional(),
    abrechnungsmodell: Abrechnungsmodell.optional(),
    bestellurkundeDocumentId: z.number().int().positive().nullable().optional(),
    notiz: z.string().max(5000).nullable().optional(),
});
